


































import { ClientFilterI, FlotaFilterI } from '@/interfaces/Filters';
import { Vue, Component, Prop } from 'vue-property-decorator';
import ClientFilter from '@/components/Filters/ClientFilter.vue';
import { AxiosResponse } from 'axios';
import { MSResponse } from '@/interfaces/MS';
import { FlotaVehiculoService } from './flotaVehiculoService';
import { FlotaVehiculoInterface } from './FlotaVehiculoInterface';

@Component({
  components: {
    ClientFilter,
  },
})
export default class AsignacionDialog extends Vue {
  @Prop() readonly flota: FlotaFilterI;
  @Prop() readonly vehiculo: FlotaVehiculoInterface;
  dialog: boolean = false;
  client: ClientFilterI = { id: '', nombre: '', rut: '' };
  $snotify: any; //TODO: Esto deberia ser una variable global para toda la aplicacion usando Vue.prototype
  flotaVehiculoService = new FlotaVehiculoService();

  async asignar() {
    let axiosResponse: AxiosResponse<MSResponse<any>>;
    if (this.flota) {
      axiosResponse = await this.flotaVehiculoService.assignFlota({
        client: this.client,
        flota: this.flota,
      });
    } else {
      axiosResponse = await this.flotaVehiculoService.assignVehicle(
        this.client.rut,
        this.vehiculo
      );
    }
    const msResponse: MSResponse<any> = axiosResponse.data;
    if (msResponse.CODIGO_RESPUESTA === '1') {
      this.$snotify.success(msResponse.MENSAJE_RESPUESTA, {
        timeout: 3000,
      });
    } else {
      this.$snotify.error(msResponse.MENSAJE_RESPUESTA, {
        timeout: 3000,
      });
    }
    this.client = { id: '', nombre: '', rut: '' };
    this.dialog = false;
  }
}
